import { Radio, styled } from '@mui/material';

const StyledRadio = styled(Radio)(({ theme }) => ({
  '&.Mui-checked': {
    color: theme.palette.secondary[500],
  },
}));

export { StyledRadio };
